

















import {
  defineComponent,
  ref,
  useFetch,
  useRoute,
  watch,
} from "@nuxtjs/composition-api";
import { CmsBlock, useContent } from "~/composables";
import HTMLContent from "~/components/HTMLContent.vue";
import {trackLogoClick} from '~/helpers/trackings/layout';
import { ISTITUTIONAL_SITE } from "~/utils/constants/store";
import useLanding from "~/composables/useLanding";

export default defineComponent({
  components: {
    HTMLContent,
  },
  setup() {
    const {labelDescriptionFooter} = useLanding()
    const { loadBlocks } = useContent();
    const footerBlock = ref<CmsBlock | null>(null);
    const route = useRoute();
    const descriptionFooter = ref<string | null>(null);
    useFetch(async () => {
      const result = await loadBlocks({ identifiers: ["footer_paywall"] });
      footerBlock.value = result[0];
    });
    watch(() => labelDescriptionFooter.value, (newValue) => {
      // Non mostrare labelDescriptionFooter nel footer se siamo nella pagina Attivazioni
      const isAttivazioniPage = route.value.path?.toLowerCase().includes('attivazioni') || route.value.name?.toLowerCase().includes('attivazioni');
      descriptionFooter.value = isAttivazioniPage ? null : newValue;
    }, { immediate: true });
    return {
      footerBlock,
      trackLogoClick,
      descriptionFooter,
      routeName: route.value.name,
      logoLink : ISTITUTIONAL_SITE
    };
  },
  methods:{
    goToLink(){
      window.location.href = ISTITUTIONAL_SITE;
    }
  }
});
